module.exports = __webpack_public_path__ + "img/170-170-CMS 16_9.4db65c62.png";